<nav class="navbar navbar-default">
  <div class="container">
    <div class="collapse navbar-collapse">
      <ng-content>
      </ng-content>
    </div>
  </div>
</nav>
